export const services = [
  {
    id: "menage-hebdomadaire",
    path: "/femme-de-menage-val-deurope/",
    title: "Femme de ménage hebdomadaire à Val d'Europe",
    shortTitle: "Ménage hebdomadaire",
    summary:
      "Un service de ménage hebdomadaire à domicile pour les particuliers de Val d'Europe, pensé pour entretenir le logement avec régularité et continuité.",
    details: [
      "Passage chaque semaine selon l'organisation convenue avec le foyer.",
      "Entretien courant des sols, surfaces, cuisine et sanitaires.",
      "Dépoussiérage et soin général des pièces de vie.",
      "Priorités définies avec le client pour adapter le service aux habitudes du logement.",
      "Relation suivie pour installer une organisation durable."
    ],
    useCases: [
      "Foyer souhaitant déléguer l'entretien courant chaque semaine",
      "Domicile familial à maintenir propre avec régularité",
      "Organisation durable autour des habitudes du foyer"
    ],
    faq: [
      {
        q: "À quelle fréquence Arklis intervient-il ?",
        a: "Arklis propose exclusivement des interventions hebdomadaires, avec un passage chaque semaine selon l'organisation convenue avec le foyer."
      },
      {
        q: "Arklis propose-t-il des passages à la demande ?",
        a: "Non. Arklis se consacre exclusivement au ménage hebdomadaire afin de proposer un service régulier, suivi et adapté aux habitudes de chaque foyer."
      },
      {
        q: "Que peut couvrir le ménage hebdomadaire ?",
        a: "La prestation porte sur l'entretien courant du domicile : sols, dépoussiérage, cuisine, sanitaires, surfaces courantes et priorités définies avec le client."
      },
      {
        q: "Comment obtenir un tarif ?",
        a: "Chaque logement et chaque besoin étant différent, Arklis ne publie pas de tarif standard. Vous pouvez remplir le formulaire de contact ou appeler le 06 65 76 31 58 afin d'échanger sur votre besoin."
      }
    ]
  }
];
